export default {
    methods: {
        openAddModal() {
            this.$refs.addModal.showModal = true
        },
        closeModal() {
            this.showModal = false
        },
        openRestrictModal() {
            this.$refs.restrictModal.restrictionModal = true
        },
        closeRestrictModal() {
            this.restrictionModal = false
        }
    }
};